import { getArchitectureSymbolSvgPath } from "../../../components/Views/SymbolLibraryTabs";
import {
  getUserModel3DTitle,
  UserModel3DLibraryItem,
} from "./userModel3DTypes";

export const userModelArchitectureSymbolSvgResolver = {
  resolve: getArchitectureSymbolSvgPath,
};

const createUserModelFootprintSvg = (name: string) => {
  const initials =
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase())
      .join("") || "3D";
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 70"><rect x="4" y="4" width="92" height="62" rx="8" fill="#ffffff" stroke="#000000" stroke-width="4"/><path d="M14 56 L86 14 M14 14 L86 56" fill="none" stroke="#7a8794" stroke-width="3" stroke-linecap="round"/><text x="50" y="42" text-anchor="middle" font-family="Arial, sans-serif" font-size="20" font-weight="700" fill="#2f3a45">${initials}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

export const getUserModel3DGeneratedFootprintPath = (
  model: Pick<UserModel3DLibraryItem, "footprintSvg" | "name" | "displayTitle">,
) => {
  if (model.footprintSvg) {
    return `data:image/svg+xml;utf8,${encodeURIComponent(model.footprintSvg)}`;
  }
  return createUserModelFootprintSvg(getUserModel3DTitle(model));
};

/** 2D plan icon: chosen standard symbol, else generated / placeholder footprint. */
export const getUserModel3DPlanSvgPath = (
  model: Pick<
    UserModel3DLibraryItem,
    "architectureSymbolKey" | "footprintSvg" | "name" | "displayTitle"
  >,
) => {
  const architectureKey = model.architectureSymbolKey?.trim();
  if (architectureKey) {
    const architectureSvg =
      userModelArchitectureSymbolSvgResolver.resolve(architectureKey);
    if (architectureSvg) return architectureSvg;
  }
  return getUserModel3DGeneratedFootprintPath(model);
};
